/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const ArrowBackDouble = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 15 10" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M14.74 8.52L11 4.88l3.7-3.38a.89.89 0 0 0 .1-1.2.77.77 0 0 0-1.14-.09l-4.38 4a.88.88 0 0 0-.28.63.9.9 0 0 0 .26.64l4.37 4.29a.82.82 0 0 0 .56.23.79.79 0 0 0 .59-.27.9.9 0 0 0-.04-1.21zM2 4.87L5.72 1.5A.9.9 0 0 0 5.8.29.78.78 0 0 0 4.66.21l-4.38 4a.86.86 0 0 0-.28.63.9.9 0 0 0 .26.64l4.38 4.29a.78.78 0 0 0 .55.23.77.77 0 0 0 .59-.28.89.89 0 0 0 0-1.2z" />
      </g>
    </svg>
  </span>
);

ArrowBackDouble.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

ArrowBackDouble.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default ArrowBackDouble;
